import t from "../../../i18n/i18n";

function Logo() {
  return (
    <div className="brand-logo">
      <a href={t("Config.MainSite")}>
        <img src={t("Images.A021")} alt="" />
      </a>
    </div>
  );
}

export default Logo;
